var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isEditMode)?_c('sc-image',{attrs:{"media":_vm.mainImage,"editable":_vm.editable}}):_c('ShImage',{attrs:{"srcset":_vm.mainImage.src,"alt":_vm.mainImage.alt}})}
var staticRenderFns = []

export { render, staticRenderFns }